module.exports = __webpack_public_path__ + "img/active-menu-gray.9d247cfb.svg";